module.exports = "https://r.nearpod.com/assets/media/fonts/AvenirLTStd-LightOblique.ttf";